import { GpsPoint } from "./gpsPoint";

/**
 * How a heatmap's pitch calibration was produced (SCORZA-702). Persisted on the
 * GPS file so we can tell auto-calibrations apart from user ones — e.g. to re-run
 * an improved model over `pointnet-*` calibrations without clobbering `human`
 * ones, and to measure auto-calibration quality in aggregate.
 */
export enum PitchCalibrationMethod {
    /** The user placed the corners via the manual calibration flow. */
    Human = "human",
    /** Predicted by the PitchNet model (research exp24). */
    PointNet = "pointnet-exp24",
}

export interface GpsCalibrationPoints {
    leftCorner: GpsPoint;
    rightCorner: GpsPoint;
    midfield: GpsPoint;
    flip?: boolean;
    /** Which method produced these points — see {@link PitchCalibrationMethod}. */
    calibratedBy?: PitchCalibrationMethod;
}
